module.exports = __webpack_public_path__ + "img/exterior-tiles.72471ec4.svg";